import { render, staticRenderFns } from "./AlbumComments.vue?vue&type=template&id=6da0e3a1&"
import script from "./AlbumComments.vue?vue&type=script&lang=js&"
export * from "./AlbumComments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports